import { useEffect } from "react";
import SEOHead from "@/components/SEOHead";
import SkipToContent from "@/components/SkipToContent";
import NavV2 from "@/components/homev2/NavV2";
import LeadFormV2 from "@/components/homev2/LeadFormV2";
import FooterV2 from "@/components/homev2/FooterV2";
import { captureUtmParams } from "@/lib/analytics";

const Rencontre = () => {
  useEffect(() => {
    captureUtmParams();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Demander une rencontre | Agence 8020"
        description="Remplissez le formulaire de premier contact pour obtenir une rencontre avec l'équipe d'Agence 8020 : marketing, contenu et génération de leads au Québec."
        canonical="https://agence8020.com/rencontre"
      />
      <SkipToContent />
      <NavV2 />

      <main id="main">
        <section className="border-b border-border pt-32 pb-10 md:pt-40 md:pb-14">
          <div className="mx-auto max-w-[1280px] px-6 md:px-8">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-primary">
              Premier contact
            </p>
            <h1 className="mt-6 max-w-3xl font-heading text-[clamp(2rem,5.5vw,3.5rem)] font-semibold leading-[1.05] tracking-tight">
              Parlons de votre entreprise.
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
              Remplissez le formulaire ci-dessous. Notre équipe l'analyse et communique
              avec vous pour planifier une rencontre si nous croyons pouvoir avoir un réel
              impact sur votre croissance.
            </p>
          </div>
        </section>

        <LeadFormV2 />
      </main>

      <FooterV2 />
    </div>
  );
};

export default Rencontre;
